<h2 mat-dialog-title>Contract Details</h2>

<mat-dialog-content>
  <div class="info-container">

    <div class="info-section">
      <h3>Basic Information</h3>
      <div class="info-row">
        <span class="label">ID:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.id)">
          {{ data.contract.id }}
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      <div class="info-row">
        <span class="label">Name:</span>
        <span class="value">{{ data.contract.name || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Note:</span>
        <span class="value">{{ data.contract.note || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Target Type:</span>
        <span class="value">{{ data.contract.target_type }}</span>
      </div>
    </div>

    <div class="info-section">
      <h3>Status</h3>
      <div class="info-row">
        <span class="label">Status:</span>
        <span class="value status-badge" [ngClass]="'status-' + data.contract.status.toLowerCase()">
          {{ data.contract.status }}
        </span>
      </div>
      <div class="info-row">
        <span class="label">Payment:</span>
        <span class="value payment-badge" [ngClass]="data.contract.payment_status === 'Payed' ? 'payed' : 'not-payed'">
          {{ data.contract.payment_status }}
        </span>
      </div>
      <div class="info-row">
        <span class="label">Archived:</span>
        <span class="value">{{ data.contract.archived ? 'Yes' : 'No' }}</span>
      </div>
      @if (data.contract.failed_reason) {
      <div class="info-row">
        <span class="label">Fail Reason:</span>
        <span class="value error-text">{{ data.contract.failed_reason }}</span>
      </div>
      }
    </div>

    <div class="info-section">
      <h3>Coins</h3>
      <div class="info-row">
        <span class="label">Target:</span>
        <span class="value">{{ formatCoins(data.contract.target_coins) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fee:</span>
        <span class="value">{{ formatToman(data.contract.fee) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fee Amount:</span>
        <span class="value">{{ formatToman(data.contract.fee_amount) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Sent:</span>
        <span class="value">{{ formatCoins(data.contract.sent_coins) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Received:</span>
        <span class="value">{{ formatCoins(data.contract.received_coins) }}</span>
      </div>
    </div>

    @if (data.contract.allocations) {
    <div class="info-section">
      <h3>Allocations Summary</h3>
      <div class="info-row">
        <span class="label">Total:</span>
        <span class="value">{{ data.contract.allocations.total }}</span>
      </div>
      <div class="info-row">
        <span class="label">Locked:</span>
        <span class="value">{{ data.contract.allocations.locked }}</span>
      </div>
      <div class="info-row">
        <span class="label">Bought:</span>
        <span class="value">{{ data.contract.allocations.bought }}</span>
      </div>
      <div class="info-row">
        <span class="label">Released:</span>
        <span class="value">{{ data.contract.allocations.released }}</span>
      </div>
      <div class="info-row">
        <span class="label">Expired:</span>
        <span class="value">{{ data.contract.allocations.expired }}</span>
      </div>
    </div>
    }

    <div class="info-section">
      <h3>Timestamps</h3>
      <div class="info-row">
        <span class="label">Started At:</span>
        <span class="value">{{ formatDate(data.contract.started_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Finished At:</span>
        <span class="value">{{ formatDate(data.contract.finished_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Created At:</span>
        <span class="value">{{ formatDate(data.contract.created_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Updated At:</span>
        <span class="value">{{ formatDate(data.contract.updated_at) }}</span>
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
